"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var truncateRichText_1 = __importDefault(require("../truncateRichText"));
var getFirstImage_1 = __importDefault(require("../getFirstImage"));
function createDeckNote(data) {
    var content = JSON.stringify(truncateRichText_1.default(data.content, 200));
    var note = {
        content: content,
        type: data.type,
        category: data.category,
        title: data.title,
        subcategories: data.subcategories,
        createdAt: new Date(),
        lastViewed: new Date(),
    };
    if (data.file) {
        note.file = data.file;
        note.fileId = data.fileId;
    }
    var contentFirstImage = getFirstImage_1.default(data.content);
    if (contentFirstImage) {
        note.image = JSON.stringify(contentFirstImage);
    }
    return note;
}
exports.default = createDeckNote;
//# sourceMappingURL=createDeckNote.js.map